import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initWebVitals, mark, measure, reportJsBundleSize } from '@/lib/perf';
import { clearChunkReloadFlag } from '@/lib/lazyWithRetry';
import { initMonitoring } from '@/lib/monitoring';

// ── Build-ID für Release-Tracking (injiziert vom Deploy-Script) ──
const BUILD_ID = import.meta.env.VITE_BUILD_ID ?? 'dev';

mark('app_boot_start');
void initWebVitals();

// ── Monitoring initialisieren ──
initMonitoring({
  buildId: BUILD_ID,
  verbose: import.meta.env.DEV,
  // Wenn Sentry/eigener Endpoint vorhanden: endpoint hier setzen
  // endpoint: 'https://your-supabase.functions.supabase.co/error-tracking',
});

// ── Chunk-Reload-Flag zurücksetzen (App hat erfolgreich geladen) ──
clearChunkReloadFlag();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    mark('app_hydrated');
    measure('hydration_ms', 'app_boot_start', 'app_hydrated');
    reportJsBundleSize();
  });
});
